import { SPAWN_DURATION } from '@phaser/behaviors/Card.behavior';
import { LootObject } from '@phaser/objects/Loot.object';
import { Game } from '@phaser/scenes/Game';

export class LootDeathBehavior {
  private _scene: Game = Game.current;

  constructor(private _loot: LootObject) {
    this._startTween();
  }

  private _startTween() {
    this._scene.tweens.add({
      targets: this._loot.healthbar,
      width: 0,
      duration: 4000 + SPAWN_DURATION,
    });
  }
}